import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./time-date-counter.style";

export const OcTimeDateCounter = ({
  time,
  timeloading,
  cssClasses,
  counterLabel,
  isMobile,
}: {
  time: string | number;
  timeloading: boolean;
  cssClasses: string;
  counterLabel: string;
  isMobile: boolean;
}) => {
  const classes = useStyles({ isMobile });
  const theme = useTheme();

  return (
    <Box
      className={
        cssClasses === "leave"
          ? classes.counterContainer
          : classes.myTimeCounterContainer
      }
    >
      {timeloading ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
          height="100%"
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          className={
            cssClasses === "leave" ? classes.counter : classes.workTimeCounter
          }
        >
          {time}
        </Box>
      )}
      <Typography variant="body2" color={theme.palette.gray80.main}>
        {counterLabel}
      </Typography>
    </Box>
  );
};

export default OcTimeDateCounter;
